import api from "@/services/api";
import { Promise } from "core-js";

const BASE_URL = "/kasbon/access";

const state = {
  myPermissions: [],
  settings: [],
  loaded: false,
};

const getters = {};

const actions = {
  async loadMyPermissions(context) {
    try {
      const response = await api.get(BASE_URL + "/me");
      if (response.status === 200) {
        context.commit("SET_MY_PERMISSIONS", response.data);
        context.commit("SET_LOADED", true);
        return response.data;
      }
    } catch (error) {
      context.commit("SET_MY_PERMISSIONS", []);
      context.commit("SET_LOADED", false);
      return Promise.reject(error);
    }
    return [];
  },

  async getSettings(context) {
    try {
      const response = await api.get(BASE_URL + "/settings");
      if (response.status === 200) {
        context.commit("SET_SETTINGS", response.data);
        return response.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
    return [];
  },

  async update(context, payload) {
    try {
      const response = await api.put(BASE_URL + "/" + payload.featureKey, {
        userIds: payload.userIds,
      });
      if (response.status === 200) {
        context.commit("SET_SETTINGS", response.data);
        await context.dispatch("loadMyPermissions");
      }
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  clear(context) {
    context.commit("SET_MY_PERMISSIONS", []);
    context.commit("SET_SETTINGS", []);
    context.commit("SET_LOADED", false);
  },
};

const mutations = {
  SET_MY_PERMISSIONS(state, payload) {
    state.myPermissions = Array.isArray(payload) ? payload : [];
  },
  SET_SETTINGS(state, payload) {
    state.settings = Array.isArray(payload) ? payload : [];
  },
  SET_LOADED(state, payload) {
    state.loaded = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
